import { render, staticRenderFns } from "./FolderProperties.vue?vue&type=template&id=4fc63495&scoped=true"
import script from "./FolderProperties.vue?vue&type=script&lang=ts"
export * from "./FolderProperties.vue?vue&type=script&lang=ts"
import style0 from "./FolderProperties.vue?vue&type=style&index=0&id=4fc63495&prod&lang=scss&scoped=true"
import style1 from "./FolderProperties.vue?vue&type=style&index=1&id=4fc63495&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc63495",
  null
  
)

export default component.exports